import { useStylesheetUrl } from 'embedded/store/hooks.ts';

export function EmbeddedAppStylesheet() {
    const url = useStylesheetUrl();

    if (url) {
        return (
            <div>
                <link rel="stylesheet" type="text/css" href={url} />
            </div>
        );
    }

    return <></>;
}
